/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResearchSession } from './ResearchSession';
import {
    ResearchSessionFromJSON,
    ResearchSessionFromJSONTyped,
    ResearchSessionToJSON,
    ResearchSessionToJSONTyped,
} from './ResearchSession';

/**
 * A response to a research sessions request
 * @export
 * @interface ResearchSessionsResponse
 */
export interface ResearchSessionsResponse {
    /**
     * 
     * @type {Array<ResearchSession>}
     * @memberof ResearchSessionsResponse
     */
    researchSessions: Array<ResearchSession>;
}

/**
 * Check if a given object implements the ResearchSessionsResponse interface.
 */
export function instanceOfResearchSessionsResponse(value: object): value is ResearchSessionsResponse {
    if (!('researchSessions' in value) || value['researchSessions'] === undefined) return false;
    return true;
}

export function ResearchSessionsResponseFromJSON(json: any): ResearchSessionsResponse {
    return ResearchSessionsResponseFromJSONTyped(json, false);
}

export function ResearchSessionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResearchSessionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'researchSessions': ((json['research_sessions'] as Array<any>).map(ResearchSessionFromJSON)),
    };
}

export function ResearchSessionsResponseToJSON(json: any): ResearchSessionsResponse {
    return ResearchSessionsResponseToJSONTyped(json, false);
}

export function ResearchSessionsResponseToJSONTyped(value?: ResearchSessionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'research_sessions': ((value['researchSessions'] as Array<any>).map(ResearchSessionToJSON)),
    };
}

